var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUserNotAllow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83341 6.66683C6.83341 4.80016 8.30008 3.3335 10.1667 3.3335C12.0334 3.3335 13.5001 4.80016 13.5001 6.66683C13.5001 8.5335 12.0334 10.0002 10.1667 10.0002C8.30008 10.0002 6.83341 8.5335 6.83341 6.66683ZM16.1667 14.6668V16.0002C16.1667 16.4002 15.9001 16.6668 15.5001 16.6668C15.1001 16.6668 14.8334 16.4002 14.8334 16.0002V14.6668C14.8334 13.5335 13.9667 12.6668 12.8334 12.6668H7.50008C6.36675 12.6668 5.50008 13.5335 5.50008 14.6668V16.0002C5.50008 16.4002 5.23341 16.6668 4.83341 16.6668C4.43341 16.6668 4.16675 16.4002 4.16675 16.0002V14.6668C4.16675 12.8002 5.63341 11.3335 7.50008 11.3335H12.8334C14.7001 11.3335 16.1667 12.8002 16.1667 14.6668ZM10.1667 8.66683C9.03342 8.66683 8.16675 7.80016 8.16675 6.66683C8.16675 5.5335 9.03342 4.66683 10.1667 4.66683C11.3001 4.66683 12.1667 5.5335 12.1667 6.66683C12.1667 7.80016 11.3001 8.66683 10.1667 8.66683Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45957 4.45962C2.71341 4.20578 3.12497 4.20578 3.37881 4.45962L16.6017 17.6825C16.8555 17.9364 16.8555 18.3479 16.6017 18.6018C16.3479 18.8556 15.9363 18.8556 15.6825 18.6018L2.45957 5.37886C2.20573 5.12502 2.20573 4.71346 2.45957 4.45962Z",
    fill: "#4C4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserNotAllow);
export default __webpack_public_path__ + "static/media/ic_user_notAllow.3a36a6d6506ac5c670bc1a4ac280cdb7.svg";
export { ForwardRef as ReactComponent };